var exports = {
  "kL": "GuildVanityURLTab.module__container___X090MX",
  "dc": "GuildVanityURLTab.module__spinnerContainer___X090MX",
  "n7": "GuildVanityURLTab.module__errorAlert___X090MX",
  "$e": "GuildVanityURLTab.module__warning___X090MX",
  "au": "GuildVanityURLTab.module__warningContent___X090MX",
  "QW": "GuildVanityURLTab.module__warningIcon___X090MX",
  "r2": "GuildVanityURLTab.module__warningBody___X090MX",
  "tJ": "GuildVanityURLTab.module__warningTitle___X090MX",
  "i4": "GuildVanityURLTab.module__warningText___X090MX",
  "bQ": "GuildVanityURLTab.module__formBody___X090MX",
  "bk": "GuildVanityURLTab.module__fieldLabel___X090MX",
  "bd": "GuildVanityURLTab.module__inputRow___X090MX",
  "zo": "GuildVanityURLTab.module__inputPrefix___X090MX",
  "I6": "GuildVanityURLTab.module__inputWrapper___X090MX",
  "BK": "GuildVanityURLTab.module__helpText___X090MX",
  "CI": "GuildVanityURLTab.module__usage___X090MX",
  "JS": "GuildVanityURLTab.module__usageValue___X090MX",
  "o1": "GuildVanityURLTab.module__actions___X090MX",
};

module.exports = exports;
